class ComponentHelper {
    /**
     * Prepare parts of string like type/component to be used for dynamic import
     *
     * @param rawValue
     * @returns {*}
     */
    static prepareComponentPath(rawValue) {
        if (rawValue.indexOf('/') === -1) {
            return null;
        }
        const typeName = rawValue.split('/')[0].toLowerCase();

        let componentName = rawValue.split('/')[1];
        componentName = componentName.substr(0, 1).toUpperCase() + componentName.substr(1);

        return `${typeName}/${componentName}`;
    }

    /**
     * Iterate over all dom nodes with attribute "data-component" and use it's value to dynamically import the
     * corresponding component
     * @param parentNode
     */
    initializeDataComponents(parentNode = document) {
        for (const node of parentNode.querySelectorAll('[data-component]')) {
            this.initializeDataComponent(node);
        }
    }

    /**
     * Initialize data component with logic
     * @param node
     */
    initializeDataComponent(node) {
        const componentPath = ComponentHelper.prepareComponentPath(node.getAttribute('data-component'));

        if (typeof componentPath !== 'string') {
            return; // eslint-disable-line no-continue
        }

        import(/* webpackChunkName: "[request]" */ `../../../components/${componentPath}`).then((Component) => {
            const comp = new Component.default(node); // eslint-disable-line new-cap
            comp.init();
        }).catch((e) => console.info(e.message)); // eslint-disable-line no-console
    }

    /**
     * Initialize immediate components
     */
    initializePage() {
        const immediateComponents = document.querySelectorAll('[data-component]');

        for (const component of immediateComponents) {
            this.initializeDataComponent(component);
        }
    }
}

export default ComponentHelper;
